import React from 'react';
import Img from 'gatsby-image';
import SocialIcon from '../SocialIcon';
import { FooterContainer, CopyRight } from './styles';
import { SharpImage } from '../../interfaces/SharpImage';
import useFooterData from './dataQuery';
import { playStoreUrl, appStoreUrl } from '../../constants';
import { FaLinkedinIn, FaInstagram, FaFacebookF, FaYoutube } from 'react-icons/fa';

interface FooterProps {
  appText: string;
  icon: string;
  copyRight: string;
  info: Array<{ title: string; link: string }>;
  imagePlayStore: SharpImage;
  imageAppStore: SharpImage;
  imageBar: SharpImage;
  facebookUrl: string;
  linkedInUrl: string;
  instagramUrl: string;
  youtubeUrl: string;
}

const Footer: React.FC = () => {
  const data: FooterProps = useFooterData();

  return (
    <FooterContainer>
      <div className="column is-12 is-flex">
        <div className="column is-4 social">
          <img src={`img/${data.icon}`} alt="Allya" />
          <div className="icons">
            <SocialIcon title="linkedin" link={data.linkedInUrl}>
              <FaLinkedinIn color="#C40023" />
            </SocialIcon>

            <SocialIcon title="instagram" link={data.instagramUrl}>
              <FaInstagram color="#C40023" />
            </SocialIcon>

            <SocialIcon title="facebook" link={data.facebookUrl}>
              <FaFacebookF color="#C40023" />
            </SocialIcon>

            <SocialIcon title="youtube" link={data.youtubeUrl}>
              <FaYoutube color="#C40023" />
            </SocialIcon>
          </div>
        </div>
        <div className="column is-4">
          <ul className="menu-list is-flex">
            {data.info &&
              data.info.map((el) => (
                <li key={el.title}>
                  <a className="navbar-item" target="_blank" rel="noopener noreferrer" href={el.link}>
                    {el.title}
                  </a>
                </li>
              ))}
          </ul>
        </div>
        <div className="column is-4 store-links">
          <span>{data.appText}</span>
          <div className="logos">
            <a href={playStoreUrl} rel="noopener noreferrer" target="_blank">
              <Img fixed={data.imagePlayStore.childImageSharp.fixed} alt="play-store" />
            </a>
            <a href={appStoreUrl} rel="noopener noreferrer" target="_blank">
              <Img fixed={data.imageAppStore.childImageSharp.fixed} alt="app-store" />
            </a>
          </div>
        </div>
      </div>
      <CopyRight bg={data.imageBar.childImageSharp.fluid.src}>{data.copyRight}</CopyRight>
    </FooterContainer>
  );
};

export default Footer;
